<template>
  <div id="friendstab" class="contentmodaldiv" data-backdrop="false">
    <div class="modaldiv">
      <div class="contentmodal animate__animated animate__bounceInDown">
        <button class="closepopup" data-dismiss="modal">
          <i class="fas fa-times"></i>
        </button>
        <div class="login">
          <h1>แนะนำเพื่อน</h1>
          <div class="wallet1">
            <div class="boxwallet boxout mb-2">
              <div class="text-left">
                <div class="colflex">
                  <div class="creditflex">
                    <small>เครดิตคงเหลือ</small>
                    <div class="colorBlue">
                      <span id="credit_wallet" class="">{{ UserInfo.internalWallet.affiliateWallet }}</span>
                    </div>
                  </div>
                  <div class="btnflex">
                    <a href="javascript:{}" @click="WithdrawAffiliate()" class="btnTransfer"
                      >โยกเข้ากระเป๋าเกมส์</a
                    >
                  </div>
                </div>
                <!-- <span class="textlist">
                  แนะนำเพื่อนได้รับฟรี 1.00 เครดิต/คน
                </span> -->
              </div>
            </div>
          </div>
          
            <div class="flex2">
              <div class="wallet2">
                <div class="boxwallet boxin nopadding">
                  <small>แนะนำแล้ว</small>
                  <div class="colorBlue">
                    <span class="">{{ Users.length }}</span>
                  </div>
                </div>
              </div>
            </div>
            
          </div>
          <div class="text-center friendtext">
            คัดลอกลิงค์
            <div class=" form-group mb-0">
              <div class="el-input">
                <i class="fad fa-users-medical"></i>
                <input
                  type="text"
                  @click="copyAF(affiliateLink)"
                  id="friendlink"
                  readonly="readonly"
                  :value="affiliateLink"
                  class="inputstyle friendlink"
                />
              </div>
            </div>
          </div>
       
        </div>
      </div>
      <div class="overlaymodal"></div>
    </div>

</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { UserInfoMixins } from "@/mixins/UserInfo.js";
import { PrefixMixins } from "@/mixins/Prefix.js";
import { BankMixins } from "@/mixins/BankService.js";
import { fetchAffiliate, WithdrawAffiliate } from "@/services/modules/af.js";
import moment from "moment";

export default {
  name: "AfForm",
  mixins: [UserInfoMixins, PrefixMixins, BankMixins],

  data() {
    return {
      income: 0,
      Users: [],
      Trans: [],
      TransIncome: [],
      userData: {},
      setting: {},
      affiliateLink: "",
    };
  },
  computed: {
    ...mapGetters([
      "getError",
      "getLoading",
      "getLineId",
      "getGameList",
      "getPromotion",
      "getPrefix",
    ]),
  },
  methods: {
    getDate: function(data) {
      return moment(data).format("DD MMMM YYYY, h:mm:ss a");
    },
    async copyAF(item) {
      this.$copyText(item, this.$refs.af);
      this.$swal.fire("คัดลอกแล้ว", "", "success");
    },
    async fetchAffiliate() {
      await fetchAffiliate((res) => {
        if (res.status) {
          this.income = res.data.balance;
          this.Trans = res.data.transaction;
          this.Users = res.data.Users;
          this.TransIncome = res.data.transaction_incomes;
          this.setting = res.data.setting;
        }
      });
    },

    async WithdrawAffiliate() {
      await WithdrawAffiliate((res) => {
        if (res.status) {
          this.$swal.fire("Success!", "", "success");
        } else {
          this.$swal.fire(res.message, "", "error");
        }
      });
    },
  },
  async mounted() {
    await this.fetchAffiliate();
    this.affiliateLink = "";
    this.affiliateLink =
    window.location.origin + "/?shareToken=" + this.UserInfo.affiliateKey;
    $(".overlaymodal").on("click", function() {
      $("#friendstab").modal("hide");
    });
  },
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/form/AfForm.vue